import React from 'react'
import { Radar } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { colors } from './colors'

const propTypes = {
  /** Use the naming standards. */
  id: PropTypes.string.isRequired,
  /** Data for the list see sample.js for the sample data */
  data: PropTypes.object,
  /** Various options see the https://www.chartjs.org/docs/latest/charts/radar.html*/
  options: PropTypes.object,
  /** Looks for the element under the event point, then returns all elements from that dataset. This is used internally for 'dataset' mode highlighting  */
  getDatasetAtEvent: PropTypes.func,
  /** Calling getElementAtEvent(event) on your Chart instance passing an argument of an event, or jQuery event, will return the single element at the event position. If there are multiple items within range, only the first is returned*/
  getElementAtEvent: PropTypes.func,
  /** A function to be called when mouse clicked on chart elements, will return all element at that point as an array.*/
  getElementsAtEvent: PropTypes.func,
  /** A function to be called when mouse clicked on chart elements, will return all element at that point as an array.*/
  onElementsClick: PropTypes.func,
  /** Trigger a redraw */
  redraw: PropTypes.bool,
  /** If you want to use your own palette, set this to false*/
  defaultColor: PropTypes.bool,
  /** Shade color: https://material-ui.com/customization/color/#color-palette*/
  shade: PropTypes.any
}

const defaultProps = {
  data: {},
  defaultColor: true,
  shade: 900
}

/**
 * ## RadarChart is a way of showing multiple data points and the variation between them.
 *
 * `RadarChart` is based on https://www.chartjs.org/docs/latest/charts/radar.html.
 *
 * ### Usage:
 * - useful for comparing the points of two or more different data sets
 */

const RadarChart = props => {
  const { data, defaultColor, shade, ...rest } = props

  const dataWithDefaults = { ...data }
  if (defaultColor) {
    dataWithDefaults.datasets = dataWithDefaults.datasets.map((set, index) => ({
      ...set,
      backgroundColor: colors(index, shade, 0.2),
      borderColor: colors(index, shade),
      pointBackgroundColor: colors(index, shade),
      pointHoverBorderColor: colors(index, shade),
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      fill: true
    }))
  }

  return <Radar data={dataWithDefaults} data-cid='RadarChart-root' {...rest} />
}

RadarChart.propTypes = propTypes
RadarChart.defaultProps = defaultProps

export default RadarChart
